import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { API } from '../../config';

import { Observable, from } from 'rxjs';

@Injectable()
export class qrCodeService {
    constructor(private api: API, private apiService: ApiService) {}

    getScanQRCode(url: string): Observable<any> {
        return from(this.apiService.get(this.api.URLS.scanQRCodeURL +'?id='+ encodeURIComponent(url), true));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/qrCode.service.ts